import { useMutation } from "@tanstack/react-query";
import { t } from "i18next";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";

import { UsageGuide } from "../../productUsageGuides.types";
import { requestUpdateUsageGuideFaqItem } from "./updateUsageGuideFaqItem.request";
import { UpdateUsageGuideFaqItemRequestBody } from "./updateUsageGuideFaqItem.types";

const useUpdateUsageGuideFaqItem = (
  options?: MutationOptions<
    UsageGuide,
    ApiServiceError<ApiError>,
    UpdateUsageGuideFaqItemRequestBody
  >
) => {
  const refetchUsageGuides = useRefetchQuery(["product-usage-guides"]);

  return useMutation({
    mutationFn: requestUpdateUsageGuideFaqItem,
    ...options,
    onSuccess: (data, variables, context) => {
      void refetchUsageGuides();
      toast.success(t("Question updated successfully"));
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useUpdateUsageGuideFaqItem;
